import { Fragment } from 'react';

import { Button } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { HookFormResolver } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import TaxReturnForm from 'app/modules/FormDefinition/components/Form';
import env from 'env';
import * as icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useGetTaxReturnById } from '../TaxReturnList/hooks';

interface ReportDetailParam {
  taxReturnId: string;
}

export function TaxReturnDetail(props: ReportDetailParam) {
  const { t } = useTranslation();
  const { taxReturnId } = props;
  const navigate = useNavigate();
  const onCancel = () => {
    navigate(`/reports/taxreturn`);
  };
  const { loading, taxreturn } = useGetTaxReturnById(taxReturnId);

  if (loading) {
    return <></>;
  }

  return (
    <HookFormResolver onSubmit={() => {}}>
      {() => {
        return (
          <Fragment>
            <TaxReturnForm
              readOnly={true}
              submit={() => {}}
              defaultValue={taxreturn?.cells}
              version={taxreturn!.formVersionId}
            />
            <hr></hr>
            <BtnToolbar>
              <BtnGroup>
                <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
              </BtnGroup>
              <BtnGroup>
                <Button
                  icon={icon.Printer}
                  text={t('common.label.print')}
                  variant="primary"
                  onClick={() => {
                    const url = `${env.appUrl}/reports/taxreturn/preview/${taxreturn!.id}`;
                    window.open(url, '_blank', 'noopener,noreferrer');
                  }}
                />
              </BtnGroup>
            </BtnToolbar>
          </Fragment>
        );
      }}
    </HookFormResolver>
  );
}
